import {Controller} from "@hotwired/stimulus"

// Copies the text of [data-clipboard-target="source"] into the clipboard.
// Optional [data-clipboard-target="button"] shows brief "Скопировано" feedback.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      this.#fallbackCopy(text)
    }

    this.#feedback()
  }

  #feedback() {
    if (!this.hasButtonTarget) return

    const btn = this.buttonTarget
    const original = btn.innerHTML
    btn.textContent = "Скопировано"
    setTimeout(() => (btn.innerHTML = original), 1500)
  }

  #fallbackCopy(text) {
    const area = document.createElement("textarea")
    area.value = text
    area.style.position = "fixed"
    area.style.opacity = "0"
    document.body.appendChild(area)
    area.select()
    document.execCommand("copy")
    document.body.removeChild(area)
  }
}
